import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthService from "../services/auth.service";
import api from "../services/api";
import { isDesktopViewport } from "../utils/viewport";
import Modal from "./UI/Modal";
import VaccineForm from "./forms/VaccineForm";
import { ListCard, EmptyState, ListRow, ChevronIcon } from "./UI/ListCard";

function Vaccines(props) {
  const [vaccines, setVaccines] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [createOpen, setCreateOpen] = useState(false);
  const [editedVaccine, setEditedVaccine] = useState(null);
  const navigate = useNavigate();
  const { calfId } = useParams();
  const calfID = props.calfID || calfId;

  const getVaccines = useCallback(() => {
    api
      .get("/vaccine/calf/" + calfID)
      .then((response) => {
        setVaccines(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error getting the vaccines!", error);
      });
  }, [calfID]);

  useEffect(() => {
    if (!AuthService.getCurrentUser()) {
      navigate("/login");
    } else {
      getVaccines();
    }
  }, [navigate, getVaccines]);

  if (isLoading) {
    return <div></div>;
  }

  return (
    <div className="dark:text-white">
      {vaccines.length === 0 ? (
        <EmptyState
          title="Ajoutez un vaccin"
          description={'Il n\'y a aucun vaccin enregistré pour ce veau. Cliquez sur "Ajouter un vaccin" pour commencer.'}
          actionLabel="Ajouter un vaccin"
          actionTo={"/nouveau_vaccin/" + calfID}
        />
      ) : (
        <ListCard
          title="Vaccins"
          addLabel="Ajouter un vaccin"
          addTo={"/nouveau_vaccin/" + calfID}
          onAdd={() => setCreateOpen(true)}
        >
          {vaccines.map((vaccine, index) => (
            <ListRow
              key={vaccine.pk_vaccine}
              to={"/vaccin/" + calfID + "/" + vaccine.pk_vaccine}
              onDesktopClick={() => {
                if (!isDesktopViewport()) return true;
                setEditedVaccine(vaccine.pk_vaccine);
                return false;
              }}
              isLast={index === vaccines.length - 1}
            >
              <div className="flex w-2/5 flex-col">
                <span>{vaccine.name}</span>
                <span className="text-sm text-stone-400">
                  {new Date(vaccine.date).toLocaleString("default", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}
                </span>
              </div>
              <div className="m-3 flex grow justify-end">
                <ChevronIcon />
              </div>
            </ListRow>
          ))}
        </ListCard>
      )}

      <Modal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        title="Ajouter un vaccin"
      >
        <VaccineForm
          calfID={calfID}
          onDone={() => {
            setCreateOpen(false);
            getVaccines();
          }}
          onCancel={() => setCreateOpen(false)}
        />
      </Modal>

      <Modal
        open={editedVaccine !== null}
        onClose={() => setEditedVaccine(null)}
        title="Modifier un vaccin"
      >
        <VaccineForm
          calfID={calfID}
          vaccineId={editedVaccine}
          onDone={() => {
            setEditedVaccine(null);
            getVaccines();
          }}
          onCancel={() => setEditedVaccine(null)}
        />
      </Modal>
    </div>
  );
}

export default Vaccines;
